import React, { useState, useEffect } from "react";
import NewButton from "./NewButton";
import "./PopUpModal.css";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { firestore } from "../firebase.config";

const EmployeeAccountСollaboration = ({ children, currentEmployee, title, deleteBtn, subText, text, sendIcon, disableBtn,
  onClose, showClose = true, iconBgColor = "#e6faf2", hideIcon = false, alignLeft,
}) => {
  const [status] = useState(currentEmployee.status);
  const [loading, setLoading] = useState(false);

  const [derivedFirstName, setDerivedFirstName] = useState("");
  const [derivedLastName, setDerivedLastName] = useState("");

  useEffect(() => {
    if (subText) {
      if (!subText.firstName && !subText.lastName && subText.name) {
        const parts = subText.name.trim().split(" ");
        setDerivedFirstName(parts[0]);
        setDerivedLastName(parts.slice(1).join(" "));
      } else {
        setDerivedFirstName(subText.firstName || "");
        setDerivedLastName(subText.lastName || "");
      }
    }
  }, [subText]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const newStatus = status === "Active" ? "Paused" : "Active";
      const updateData = {
        status: newStatus,
      };

      await firestore.collection("users").doc(currentEmployee.id).update(updateData);

      onClose();
    } catch (err) {
      console.error("Error saving employee:", err);
    }
    setLoading(false);
  };
  const handleRemoveEmployee = async () => {
    setLoading(true);
    try {
      
      await firestore.collection("users").doc(currentEmployee.id).delete();

      onClose();
    } catch (err) {
      console.error("Error Remove employee:", err);
    }
    setLoading(false);
  }

  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer max-w-md" style={{ alignItems: alignLeft ? "flex-start" : "center" }}>
        <h2 className="newPopUpModalTitle">{title}</h2>
        <div className="newPopUpModalContent w-full">
          {!hideIcon && <div className="newPopUpModalIcon" style={{ background: iconBgColor }}>{children}</div>}
          <p className="newPopUpModalText" style={{ textAlign: alignLeft ? "left" : "center" }}>
            {text}
          </p>
          {subText  && <div className="newPopUpModalTextWrap">
            <div className="employeeRemoveTextWrap border-b-[1px] border-[#F7F6F7]">
              <p className="employeeName w-1/4" >
                Role
              </p>
              <p className="newPopUpModalText" style={{ textAlign: alignLeft ? "left" : "center" }}>
                {subText?.role}
              </p>
            </div>
            <div className="employeeRemoveTextWrap border-b-[1px] border-[#F7F6F7]">
              <p className="employeeName w-1/4" >
                Name
              </p>
              <p className="newPopUpModalText" style={{ textAlign: alignLeft ? "left" : "center" }}>
              {`${derivedFirstName} ${derivedLastName}`}
              </p>
            </div>
            <div className={`employeeRemoveTextWrap ${subText.languages?.length > 0 && "border-b-[1px] border-[#F7F6F7]"}`}>
              <p className="employeeName w-1/4" >
                Email
              </p>
              <p className="newPopUpModalText" style={{ textAlign: alignLeft ? "left" : "center" }}>
                {subText?.email}
              </p>
            </div>
            {
              subText.languages?.length > 0 &&
              <div className="employeeRemoveTextWrap">
                <p className="employeeName w-1/4" >
                  Languages
                </p>
                <p className="newPopUpModalText" style={{ textAlign: alignLeft ? "left" : "center" }}>
                  {subText.languages.map((lang, index) => (
                    <span key={index}>{lang}{index !== subText.languages?.length - 1 ? ", " : ""}</span>
                  ))}
                </p>
              </div>
            }
          </div>
          }
        </div>

        <div className="newPopUpModalTextWrap">
          {
            subText && <NewButton text={loading ? "Saving..." : title} onClick={handleRemoveEmployee } deleteBtn={deleteBtn} disabled={disableBtn} width="100%" />
          }
          {
            !subText && <NewButton text={loading ? "Saving..." : title} onClick={handleSave} deleteBtn={deleteBtn} disabled={disableBtn} width="100%" />
          }

          <NewButton text={'Cancel'} width="100%" onClick={onClose} back sendIcon={sendIcon} icon={false} whiteBtn />
        </div>
        {showClose && <Close className="newPopUpModalCloseIcon" onClick={onClose} />}
      </div>
    </div>
  );
};

export default EmployeeAccountСollaboration;
